module.exports = __webpack_public_path__ + "img/inhaler.423b40ff.svg";